<!-- <section class="container-fluid no-padding">
    <breadcrumb></breadcrumb>
</section> -->
<tabset class="nav nav-tabs admin-tab">
  <div class="container">
    <tab class="dynamic-tab padding0" heading="My Open Tickets" (select)="selectTab(1)" [active]="activetab==1">
      <div class="card customer-service-search-border no-padding">

        <div class="col-md-12 margintop-32">
          <div class="form-group col-xs-12 col-md-3">
            <label for="Search By">
              Search By
              <span class="ico-help fa fa-question-circle" title="Search By"></span>
            </label>
            <select class="form-control" ng-reflect-model="Search By">
              <option value="0: " ng-reflect-ng-value="">Select</option>
              <option value="1: FBO_ID" ng-reflect-ng-value="FBO_ID">FBO ID</option>
              <option value="2: FBO_Retail_Email" ng-reflect-ng-value="FBO_Retail_Email">FBO/Retail Customer Email</option>
              <option value="1: Item_No" ng-reflect-ng-value="Item_No">Item No</option>
              <option value="1: Order_ID" ng-reflect-ng-value="Order_ID">Order ID</option>
              <option value="1: Dispute_Created_By" ng-reflect-ng-value="Dispute_Created_By">Dispute Created By</option>
            </select>
          </div>
          <div class="form-group col-xs-12 col-md-3 margintop-32">
            <input class="form-control" placeholder="" tabindex="0" type="text">
          </div>
          <div class="form-group col-xs-12 col-md-3 margintop-32">
            <button class="btn search-button" tabindex="0" type="button">
              <i class="fa fa-search pad-r-8"></i> Search
            </button>
          </div>
        </div>

      </div>
      <div class="col-md-12">
        <div class="form-group col-xs-12 col-md-3">
          <label for="Ticket Number">
            Ticket Number
            <span class="ico-help fa fa-question-circle" title="Ticket Number"></span>
          </label>
          <input class="form-control" placeholder="" tabindex="0" type="text">
        </div>
        <div class="form-group col-xs-12 col-md-3 clearfix">
          <label for="Department">
            Assign to Department
            <span class="ico-help fa fa-question-circle" title="Department"></span>
          </label>
          <select class="form-control" ng-reflect-model="Department">
            <option value="0: " ng-reflect-ng-value="">Select</option>
            <option value="1: Human_Resource" ng-reflect-ng-value="Human_Resource">Human Resource</option>
          </select>
        </div>
        <div class="form-group col-xs-12 col-md-3">
          <label for="Assign To">
            Assign to User
            <span class="ico-help fa fa-question-circle" title="Assign to User"></span>
          </label>
          <input class="form-control" placeholder="" tabindex="0" type="text">
        </div>
        <div class="form-group col-xs-12 col-md-3">
          <label for="Status">
            Status
            <span class="ico-help fa fa-question-circle" title="Status"></span>
          </label>
          <select class="form-control" ng-reflect-model="Status">
            <option value="0: " ng-reflect-ng-value="">Select</option>
            <option value="1: New" ng-reflect-ng-value="New">New</option>
            <option value=":2 In_Progress" ng-reflect-ng-value="In_Progress">In Progress</option>
            <option value="3: Closed" ng-reflect-ng-value="Closed">Closed</option>
            <option value="4: ReOpen" ng-reflect-ng-value="ReOpen">ReOpen</option>
          </select>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group col-xs-12 col-md-3">
          <label for="Priority">
            Priority
            <span class="ico-help fa fa-question-circle" title="Priority"></span>
          </label>
          <select class="form-control" ng-reflect-model="Priority">
            <option value="0: " ng-reflect-ng-value="">Select</option>
            <option value="1: Low" ng-reflect-ng-value="Low">Low</option>
            <option value="2: Medium" ng-reflect-ng-value="Medium">Medium</option>
            <option value="3: High" ng-reflect-ng-value="High">High</option>
          </select>
        </div>
        <div class="form-group col-xs-12 col-md-3">
          <label for="Ticket Type">
            Ticket Type
            <span class="ico-help fa fa-question-circle" title="Ticket Type"></span>
          </label>
          <select class="form-control" ng-reflect-model="Ticket Type">
            <option value="0: " ng-reflect-ng-value="">Select</option>
            <option value="1: Account" ng-reflect-ng-value="Account">Account</option>
            <option value="2: Applications" ng-reflect-ng-value="Applications">Applications</option>
            <option value="3: Bonus" ng-reflect-ng-value="Bonus">Bonus</option>
            <option value="4: Orders" ng-reflect-ng-value="Orders">Orders</option>
            <option value="5: Bonus reissue" ng-reflect-ng-value="Bonus reissue">Bonus reissue</option>
          </select>
        </div>
        <div class="form-group col-xs-12 col-md-3">
          <label for="Sub Type">
            SubType
            <span class="ico-help fa fa-question-circle" title="Sub Type"></span>
          </label>
          <select class="form-control" ng-reflect-model="Sub Type">
            <option value="0: " ng-reflect-ng-value="">Select</option>
            <option value="1: Cancel_order" ng-reflect-ng-value="Cancel_order">Cancel order</option>
            <option value="2: Issue_with_order" ng-reflect-ng-value="Issue_with_order">Issue with order</option>
          </select>
        </div>
      </div>

      <div class="col-md-12 margintop-32">
        <div class="table-responsive pane-hScroll">
          <table class="table table-striped custab ticket-dashbaord">
            <thead>
              <tr>
                <th>Priority &nbsp;
                  <i class="fa fa-sort" style="font-size:12px"></i>
                </th>
                <th>Ticket No #&nbsp;
                  <i class="fa fa-sort" style="font-size:12px"></i>
                </th>
                <th>Due Date&nbsp;
                  <i class="fa fa-sort" style="font-size:12px"></i>
                </th>
                <th>Subject&nbsp;
                </th>
                <th>Status&nbsp;
                </th>
                <th>Ticket Type</th>
                <th>Sub Type</th>
                <th>Created Date&nbsp;</th>
                <th>Last Modified Date</th>
                <th>Attachment</th>
                <th>Assign to User&nbsp;
                  <i class="fa fa-sort" style="font-size:12px"></i>
                </th>
                <th>Spam&nbsp;
                </th>
                <th>Actions&nbsp;
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span class="label label-default" style="background-color:#83e9d2;">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;Low</td>
                <td>001043821</td>
                <td>01/Mar/2018</td>
                <td>Product Complaint</td>
                <td>In Progress</td>
                <td>Account</td>
                <td>Issue with order</td>
                <td>01/feb/2018 12:20 MST</td>
                <td>01/feb/2018 12:20 MST</td>
                <td>
                  <span class="fa fa-paperclip"></span>
                </td>
                <td>Finance Support US</td>
                <td>
                  <input type="checkbox">
                </td>
                <td class="options">
                  <i class="fa fa-eye text-success btn-view" title="View"></i>
                  <i class="fa fa-pencil btn-EditIcon" title="Edit"></i>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="label label-default" style="background-color:#5eb7ff;">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;Medium</td>
                <td>001043821</td>
                <td>01/Mar/2018</td>
                <td>Product Complaint</td>
                <td>In Progress</td>
                <td>Account</td>
                <td>Issue with order</td>
                <td>01/feb/2018 12:20 MST</td>
                <td>01/feb/2018 12:20 MST</td>
                <td>product_complaint_details.pdf</td>
                <td>Finance Support US</td>
                <td>
                  <input type="checkbox">
                </td>
                <td class="options">
                  <i class="fa fa-eye text-success btn-view" title="View"></i>
                  <i class="fa fa-pencil btn-EditIcon" title="Edit"></i>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="label label-default" style="background-color:#ff7979;">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;High</td>
                <td>001043821</td>
                <td>01/Mar/2018</td>
                <td>Product Complaint</td>
                <td>In Progress</td>
                <td>Account</td>
                <td>Issue with order</td>
                <td>01/feb/2018 12:20 MST</td>
                <td>01/feb/2018 12:20 MST</td>
                <td>product_complaint_details.pdf</td>
                <td>Finance Support US</td>
                <td>
                  <input type="checkbox">
                </td>
                <td class="options">
                  <i class="fa fa-eye text-success btn-view" title="View"></i>
                  <i class="fa fa-pencil btn-EditIcon" title="Edit"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </tab>
    <tab class="padding0" heading="My Team Tickets" (select)="selectTab(2)" [active]="activetab==2">

    </tab>
    <tab class="padding0" heading="My Recent Tickets" (select)="selectTab(3)" [active]="activetab==3">

    </tab>
  </div>
</tabset>

<!--<tabset class="nav nav-tabs  admin-tab"  [justified]="true">
        <tab class="dynamic-tab padding0" heading="Work Tickets" (select)="selectTab(1)" [active]="activetab==1">
            <work-tickets></work-tickets>
        </tab>
         <tab class="padding0" heading="Email Tickets" (select)="selectTab(2)" [active]="activetab==2">
            
        </tab>
         <tab class="padding0" heading="Dispute Tickets" (select)="selectTab(3)" [active]="activetab==3">
            
        </tab>
         <tab class="padding0" heading="Product Tickets" (select)="selectTab(4)" [active]="activetab==4">
            
        </tab>
    </tabset>-->


<!--<ul class="ul">
        <li>
            <span><a class="store-name" title="Work Tickets" >
                Work Tickets
            </a>
            <span>
        </li>
    </ul>-->


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/ticket-dashboard.component.html